import lodash from 'lodash'
import moment from 'moment'

import { checksum } from '../../../../1stlog-ui/src/utils'
import { TOrderEntryBackendProduct, TOrderEntryProductTiming } from '../types'

export function generateTimeOptions(
  product: TOrderEntryBackendProduct,
): Array<TOrderEntryProductTiming> {
  const {
    // pickup
    pickupType,
    isPickupAppointmentAllowed,
    pickupFromTime,
    pickupUntilTime,
    pickupAppointmentUntilTime,
    manualPickupStartAllowed,
    manualPickupAppointmentStartAllowed,

    // delivery
    deliveryType,
    deliveryFromTime,
    deliveryUntilTime,
    isDeliveryAppointmentAllowed,

    // other
    typeOfOperation,
    timings,
  } = product

  // console.log('timings', timings)

  /*

additionalService: null
avis: "2021-05-05T08:00:00.000Z"
from: "2021-05-05T05:00:00.000Z"
minAvisFromNow: 120
minimalTimespan: 30
mode: "lefttimespan"
requiresConfirmation: false
type: "pickup"
until: "2021-05-05T06:00:00.000Z"

*/

  let timeOptions = lodash.map(timings, (timing: any) => {
    const {
      additionalService,
      avis,
      from,
      minAvisFromNow,
      minimalTimespan,
      mode,
      requiresConfirmation,
      type,
      until,
    } = timing

    return {
      id: checksum(JSON.stringify(timing)),
      name: (settings) => {
        const { from, until, mode, minAvisFromNow } = settings

        const additionalService = lodash.get(settings, 'additionalService')
        const description = lodash.get(additionalService, 'description')

        if (description) {
          let res = `${description}`
          res += ''
          const untilTime = lodash.get(settings, 'until')
          // TODO: enable properly only when required
          // if (!settings?.hideUntilTime) {
          //   res += ` bis ${moment(untilTime).format('HH:mm')} Uhr`
          // }
          return res
        }

        // return `${moment(from).format("HH:mm")}-${moment(until).format(
        //   "HH:mm"
        // )}`

        const namesByMode = {
          timespan: i18n.t('free_time_window', 'Freies Zeitfenster'),
          lefttimespan: i18n.t('free_pickup_time', 'Freie Abholzeit'),
          righttimespan: i18n.t('free_delivery_time', 'Freie Zustellzeit'),
        }

        return lodash.get(namesByMode, mode, i18n.t('standard', 'Standard'))
      },
      ...timing,
      timing,
      info: undefined,
      isPickup: type === 'pickup',
      isDelivery: type === 'delivery',
      additionalAvis: true,
      fixedTime: false,
      time: { end: moment(pickupUntilTime).format('HH:mm') },
      debug: true,
      type: 'v2',
    }
  })

  timeOptions = lodash.map(timeOptions, (t) => ({
    ...t,
    allTimings: timeOptions,
  }))

  return timeOptions
}
